<template>
  <div class="bg-hex-$portalColumnBgColor pt-30px pb-10px w-$portalContainerWidth mx-auto px-20px">
    <div class="w-$portalContainerWidth mx-auto flex flex-wrap">
      <div
        class="bg-hex-fff h-100px app-item text-14px text-center cursor-pointer pt-18px px-18px mr-20px mb-20px"
        v-for="item in tableData"
        :key="item.id"
        @click="toApp(item)"
      >
        <div class="image">
          <img :src="getAppIcon(item.normalIcon)" alt="" class="w-40px h-40px mx-auto" />
          <img :src="getAppIcon(item.hoverIcon)" alt="" class="w-40px h-40px mx-auto" />
        </div>
        <!-- <i :class="getIconClass(item.icon)" class="app-icon"></i> -->
        <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
          <p class="mt-10px truncate">{{ item.name }}</p>
        </el-tooltip>
      </div>
    </div>
    <AddSSOConfig @save="ssoSave" :appConfig="appConfig" ref="addSSOConfig" />
  </div>
</template>

<script>
import { SingleSignOnApi } from '@wiz-api/workbench'
import { EafLoginApi } from '@wiz-api/auth-server'
import { getFieldValue, ssoLogin } from '../js/sso'
import AddSSOConfig from '../components/AddSSOConfig'

const singleSignOnApi = new SingleSignOnApi()
const eafLoginAPi = new EafLoginApi()
export default {
  components: {
    AddSSOConfig,
  },
  data() {
    return {
      tableData: [],
      appConfig: {},
    }
  },
  created() {
    this.getTableData()
    const { config } = Wiz.globalSettings.dynamicModules.modules['portal-homepage-nanhai']
    document.title = `应用中心 - ${config.title}`
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
    userInfo() {
      return Wiz.AuthHooks.GetUserInfo()
    },
  },
  methods: {
    async getTableData() {
      this.tableData = []
      const params = {
        name: '',
        isThirdParty: '',
        type: '',
      }
      const [err, res] = await singleSignOnApi.getAppssoSettingPage(1, 999, params)
      if (!err && res) {
        this.tableData = res.items
      }
    },
    getAppIcon(id) {
      return this.fileUrl + id
    },
    async toApp(app) {
      // 0:直接跳转 3：auth2.0
      if (app.loginType === 0) {
        const loginParams = app.moreParamSetting ? JSON.parse(app.moreParamSetting) : []
        let url = ''
        _.forEach(loginParams, (item) => {
          if (item.postType === 'url') {
            url += `&${item.fieldsName}=${getFieldValue(item)}`
          }
        })
        window.open(`${app.loginUrl}${url ? url.replace('&', '?') : ''}`)
      } else if (app.loginType === 3) {
        const [err, res] = await eafLoginAPi.takeOidcCode(
          'SSO_APP',
          app.loginUrl,
          'code',
          'openid profile'
        )
        if (!err) {
          if (res.isSuccess) {
            const loginParams = app.moreParamSetting ? JSON.parse(app.moreParamSetting) : []
            let url = ''
            _.forEach(loginParams, (item) => {
              if (item.postType === 'url') {
                url += `&${item.fieldsName}=${getFieldValue(item)}`
              }
            })
            url += `&code=${res.code}`
            window.open(`${app.loginUrl}${url ? url.replace('&', '?') : ''}`)
          } else {
            this.$message.error(res.errorMessage)
          }
        }
      } else {
        const [err, res] = await singleSignOnApi.getAppssoParamsDetail({
          userId: this.userInfo?.profile?.sub,
          appId: app.id,
        })
        if (!err) {
          if (res.id !== '00000000-0000-0000-0000-000000000000') {
            ssoLogin(app, res)
          } else {
            this.appConfig = app
            this.$refs.addSSOConfig.dialogVisible = true
          }
        }
      }
    },
    ssoSave(data) {
      ssoLogin(this.appConfig, data)
      this.getTableData()
    },
  },
}
</script>

<style lang="scss" scoped>
.app-item {
  width: calc(100% / 6 - 140px / 6);
  &:hover {
    background-color: var(--portalPrimaryColor);
    color: #fff;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      bottom: 5px;
      right: 5px;
      width: 30px;
      height: 30px;
      background: url('../image/active.png') 0 0 no-repeat;
      background-size: 100%;
    }
    .image img:last-child {
      display: block;
    }
    .image img:first-child {
      display: none;
    }
  }
  &:nth-child(6n) {
    margin-right: 0;
  }
  .image img:first-child {
    display: block;
  }
  .image img:last-child {
    display: none;
  }
}
</style>
